import { useEffect, useRef, useState } from "react"

const DOTS_LOADER_OUTPUTS = [
  "/media/dots-loader/0.png",
  "/media/dots-loader/1.png",
  "/media/dots-loader/2.png",
  "/media/dots-loader/3.png",
  "/media/dots-loader/4.png",
]

let shuffledOutputs: string[] = []
let previousOutput: string | undefined

const shuffleOutputs = () => {
  const outputs = [...DOTS_LOADER_OUTPUTS]

  for (let index = outputs.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(Math.random() * (index + 1))
    const current = outputs[index]
    outputs[index] = outputs[swapIndex]
    outputs[swapIndex] = current
  }

  return outputs
}

const getRandomDotOutput = () => {
  if (DOTS_LOADER_OUTPUTS.length === 1) return DOTS_LOADER_OUTPUTS[0]

  if (shuffledOutputs.length === 0) {
    shuffledOutputs = shuffleOutputs()
  }

  if (shuffledOutputs[0] === previousOutput && shuffledOutputs.length > 1) {
    const first = shuffledOutputs[0]
    shuffledOutputs[0] = shuffledOutputs[1]
    shuffledOutputs[1] = first
  }

  const next = shuffledOutputs.shift() || DOTS_LOADER_OUTPUTS[0]
  previousOutput = next

  return next
}

interface Props {
  label?: string
  compact?: boolean
  hideLabel?: boolean
  shuffleKey?: string | number | null
  className?: string
}

const DotsLoader = ({
  label = "Loading artwork",
  compact = false,
  hideLabel = false,
  shuffleKey,
  className = "",
}: Props) => {
  const didMount = useRef(false)
  const [dotOutput, setDotOutput] = useState(() => getRandomDotOutput())

  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true
      return
    }

    setDotOutput(getRandomDotOutput())
  }, [shuffleKey])

  return (
    <div
      className={`gallery-dots-loader ${className}`}
      data-compact={compact ? "true" : "false"}
      role={hideLabel ? undefined : "status"}
      aria-live={hideLabel ? undefined : "polite"}
      aria-hidden={hideLabel ? true : undefined}
    >
      <span className="gallery-dots-loader-mark" aria-hidden="true">
        <img
          src={dotOutput}
          alt=""
          className="gallery-dots-loader-image"
          draggable={false}
        />
      </span>
      {!hideLabel && (
        <span className="gallery-label text-gallery-muted">{label}</span>
      )}
    </div>
  )
}

export default DotsLoader
